import styled from 'astroturf/react';
import { Icon } from 'js/design_system/Icon';

// astroturf styles:
export const OuterContainer = styled.div`
  animation: surveyAttentionGrab 8s normal forwards;

  background-color: #f9f6ed;
  height: 100%;
  border: 1px solid #b08920;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px 16px 16px;
`;

export const CueContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const ExclamationIcon = styled(Icon)`
  margin-right: 8px;
  color: #b08920;
`;

export const CueTextContainer = styled.div`
  display: flex;
  flex-direction: column;

  font-family: 'Roboto';
  font-weight: 400;
  font-size: 16px;
  text-align: left;
  line-height: 20px;
  color: #202223;
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const QuestionProgress = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.1em;
  margin-bottom: 5px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 8px;
  gap: 16px;
`;

export const CompletedBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;

  position: absolute;
  top: -30px;
  z-index: 1;
  width: 141%;
  max-width: 639px;
  min-width: 320px;
  height: 56px;

  background: #f0f8f1;

  border: 1px solid #048c16;
  box-sizing: border-box;

  box-shadow:
    0px 2px 8px rgba(0, 0, 0, 0.24),
    0px 12px 16px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
`;

export const CompletedCheckmark = styled(Icon)`
  color: #048c16;
  margin-right: 8px;
`;
